<div class="tab-loading-scope" [class.is-loading]="isLoading">
  <ng-content></ng-content>

  @if (isLoading) {
    <div class="tab-loading-scope__overlay">
      <div class="tab-loading-scope__inner">
        <mat-spinner [diameter]="diameter"></mat-spinner>
        @if (label) {
          <p class="tab-loading-scope__label">{{ label }}</p>
        }
      </div>
    </div>
  }
</div>
